import { useState, useEffect } from 'react';
import { getNotificationPermission, type NotificationPermissionState } from '@/lib/pwa-push';

/**
 * Tracks the browser's notification permission for this site. Updates when the user
 * changes the setting (e.g. in another tab or in browser site settings). On iOS Safari
 * the Permissions API is not supported, so updates only occur on mount/reload.
 */
export function useBrowserNotificationPermission(): NotificationPermissionState {
  const [permission, setPermission] = useState<NotificationPermissionState>(() =>
    getNotificationPermission()
  );

  useEffect(() => {
    setPermission(getNotificationPermission());
    const nav = navigator as Navigator & {
      permissions?: {
        query(args: { name: string }): Promise<{ onchange: () => void }>;
      };
    };
    if (!nav.permissions?.query) return;
    nav.permissions
      .query({ name: 'notifications' })
      .then(perm => {
        setPermission(getNotificationPermission());
        perm.onchange = () => setPermission(getNotificationPermission());
      })
      .catch(() => {});
  }, []);

  return permission;
}
